function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm0 58.667a26.667 26.667 0 1 1 26.667-26.667 26.667 26.667 0 0 1-26.667 26.667z",
    style: {
      strokeWidth: 2.6667
    },
    "data-name": "Caminho 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.999 26.667h-2.6667a2.6667 2.6667 0 0 0 0 5.3333h2.6667v16a2.6667 2.6667 0 0 0 5.3333 0v-16a5.3333 5.3333 0 0 0-5.3333-5.3333z",
    style: {
      strokeWidth: 2.6667
    },
    "data-name": "Caminho 34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17.333,
    r: 4,
    style: {
      strokeWidth: 2.6667
    },
    "data-name": "Elipse 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f7ac1a44.svg";
export { ForwardRef as ReactComponent };